export enum ConnectorTypes {
    APPLICATION_CREATE = "APPLICATION_CREATE",
    APPLICATION_UPDATE = "APPLICATION_UPDATE",
    VERIFY_FIELDS = "VERIFY_FIELDS",
    LOOKUP = "LOOKUP",
    PREVIEW_FILE = "PREVIEW_FILE",
    DOWNLOAD_FILE = "DOWNLOAD_FILE",
    OTP="OTP"
}
